import { SortersType } from '@lumapps/lumx-filter-and-sort/types';
import { GLOBAL } from '@lumapps/translations';

export enum MICRO_APPS_SORTING {
    CREATED_ASC = 'createdAt',
    CREATED_DESC = '-createdAt',
    NAME_ASC = 'name',
    NAME_DESC = '-name',
}

export const SORTING_FIELDS: SortersType[] = [
    { id: MICRO_APPS_SORTING.CREATED_ASC, label: GLOBAL.SORT_NEWEST },
    { id: MICRO_APPS_SORTING.CREATED_DESC, label: GLOBAL.SORT_OLDEST },
    { id: MICRO_APPS_SORTING.NAME_ASC, label: GLOBAL.SORT_ALPHABETICALLY_ASC },
    { id: MICRO_APPS_SORTING.NAME_DESC, label: GLOBAL.SORT_ALPHABETICALLY_DESC },
];

export const SETUP_SIDEBAR_ITEMS = {
    settings: 'settings',
    inputVariables: 'inputVariables',
};

/**
 * Option ids for the "has a user interface" checkbox filter.
 * They map to the string representation of the `hasUi` boolean so the
 * selection can be translated back to a boolean (or `undefined` for "all").
 */
export const HAS_UI_FILTER_OPTION_IDS = {
    YES: 'true',
    NO: 'false',
} as const;
